import { useContext, useEffect, useState } from "react";
import { Context } from "../../../../context";
import { Box, Typography } from "@mui/material";
import { Layout } from "../../../../containers/layout/dashboard";
import { ListOfInstitutionsWrapper } from "./styled";
import { BaseTable } from "../../../../components/table";
import { BaseButton } from "../../../../components/button/styled";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { useNavigate } from "react-router-dom";
import { retrieveInstitutionsService } from "../../../../utils/apis/institution/retrieveInstitutions";
import Cookies from "universal-cookie";
import { BaseLabel } from "../../../../components/formfields/label/styled";
import { BaseFieldSet } from "../../../../components/formfields/fieldset/styled";
import { retrieveStatusByIdService } from "../../../../config/status/statusById";
import { useQuery } from "@tanstack/react-query";
import { BaseInput } from "../../../../components/formfields/input/styled";
import { SearchIcon } from "../../../../assets";

export const ListOfInstitutions = () => {
	const cookies = new Cookies();
	const TOKEN = cookies.getAll().TOKEN;

	const headers = [
		// the lesson here is that ID is more better off as a unique number
		{
			id: "name",
			name: "Registered Name",
		},
		{
			id: "phone",
			name: "Phone No.",
		},
		{
			id: "status",
			name: "Status",
		},
		{
			id: "",
			name: "",
		},
	];

	const navigate = useNavigate();
	const { setActiveNavItem } = useContext(Context);

	const [filter, setFilter] = useState<string>("");

	useEffect(() => {
		setActiveNavItem("Institutions");
	}, [setActiveNavItem]);

	const { data: institutions } = useQuery({
		queryKey: ["institutions", TOKEN, filter],
		queryFn: async () => {
			const data = await retrieveInstitutionsService(TOKEN, filter);
			const transformedInstitutions = await Promise.all(
				data?.map(async (institution: any) => {
					const statusObj = await retrieveStatusByIdService(
						TOKEN,
						institution.status
					);
					return {
						...institution,
						status:
							statusObj.title.charAt(0).toUpperCase() +
							statusObj.title.slice(1),
					};
				})
			);
			return transformedInstitutions;
		},
		enabled: !!TOKEN,
	});

	const handleChange = (
		e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		const value = e.target.value;
		setFilter(value);
	};

	const handleNavigateToEdit = (
		e:
			| React.MouseEvent<HTMLButtonElement, MouseEvent>
			| React.MouseEvent<HTMLSpanElement, MouseEvent>,
		id: string
	) => {
		e.preventDefault();
		navigate(`/institution/edit/${id}`);
	};

	const handleNavigateToPrevious = () => {
		return navigate(-1);
	};

	return (
		<Layout id="list-of-institutions">
			<ListOfInstitutionsWrapper>
				<Box component={"div"} className="title-box">
					<Typography
						variant="h1"
						fontFamily={"Inter"}
						fontWeight={700}
						fontSize={24}
						lineHeight={"normal"}
						color={"#373737"}
						marginBlockEnd={"calc(var(--basic-margin)/4)"}
					>
						All Institutions
					</Typography>
					<BaseButton
						variant="outlined"
						border="1px solid #D7D7D7"
						colour="#373737"
						bgcolor="#FFFFFF"
						padding="calc(var(--basic-padding)/4) calc(var(--basic-padding)/2)"
						fontSize={12}
						fontWeight={800}
						startIcon={<ArrowLeftIcon />}
						onClick={handleNavigateToPrevious}
					>
						<Typography
							variant={"button"}
							fontFamily={"inherit"}
							fontWeight={"inherit"}
							fontSize={"inherit"}
							lineHeight={"inherit"}
							color={"inherit"}
							textTransform={"inherit"}
						>
							Back
						</Typography>
					</BaseButton>
				</Box>
				<form>
					<BaseFieldSet>
						<BaseLabel colour="#505050" fontWeight={500} fontSize="15px">
							Search
						</BaseLabel>
						<BaseInput
							name="filter"
							colour="#666666"
							bgcolor="#FFFFFF"
							fontWeight={400}
							value={filter}
							placeholder="Enter MFI Name"
							onChange={(e) => handleChange(e)}
							startAdornment={
								<Box component={"div"} className="search-icon-box">
									<SearchIcon />
								</Box>
							}
						/>
					</BaseFieldSet>
				</form>
				<BaseTable
					headers={headers?.map((header) => header.name)}
					rows={institutions as Record<any, any>[]}
					location="list-of-institutions"
					handleItemClick={handleNavigateToEdit}
				/>
			</ListOfInstitutionsWrapper>
		</Layout>
	);
};
